<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g fill-rule="evenodd"><path d="M8.635 1.5v5.303l4.698-1.71.435 1.197L9.07 8l-.435-1.194V14.5h-1.27v-13h1.27Zm-5.97 3.594 4.699 1.71L6.928 8 2.23 6.29l.435-1.196Z" opacity=".45" fill="currentColor"/><path d="M8 12a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM2 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm12 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering103',
});
</script>
